import { useEffect, useState } from 'react';

// Matches Tailwind's `sm` breakpoint: below 640px counts as a phone.
const NARROW_MAX_WIDTH = 639;

const isNarrow = (maxWidth: number) =>
  typeof window !== 'undefined' && window.innerWidth <= maxWidth;

/** True while the viewport is phone-sized; follows resizes and rotation. */
export const useIsNarrowScreen = (maxWidth: number = NARROW_MAX_WIDTH): boolean => {
  const [narrow, setNarrow] = useState(() => isNarrow(maxWidth));

  useEffect(() => {
    const update = () => setNarrow(isNarrow(maxWidth));
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, [maxWidth]);

  return narrow;
};

export default useIsNarrowScreen;
